import React, { useEffect, useState } from "react";
import {
  transformResultsToCompProfileData,
  formatBoldText,
} from "../../../../../services/commonService";
import InsightTable from "../../InsightTable";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";

function MarketingGeographicCoverage({ marketingGeographicCoverage = [] }) {
  const [tabData, setTabData] = useState([]);
  const [tableBelowDescription, setTableBelowDescription] = useState("");
  const allMetrics = [
    // { key: "region", label: "Region" },
    { key: "marketing_presence", label: "Marketing Presence (HIGH)" },
    { key: "estimated_investment", label: "Estimated Investment (MEDIUM)" },
    {
      key: "digital_footprint",
      label: "Digital Footprint (HIGH)",
    },
    {
      key: "marketing_effectiveness",
      label: "Marketing Effectiveness (MEDIUM)",
    },
  ];

  const dummyData = [
    {
      region: "North America",
      primary_channel: {
        value: "Direct",
        source: "https://placeholder.source.com",
        data_type: "Derived",
        confidence_score: 0.85,
        reasoning: "Derived from partner onboarding documentation.",
      },
      primary_channel_positive_insight: {
        value: "Direct",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.85,
        reasoning: "Derived from partner onboarding documentation.",
      },
      primary_channel_negative_insight: {
        value: "Direct",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.85,
        reasoning: "Derived from partner onboarding documentation.",
      },
      primary_channel_recent_development: {
        value: "Direct",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.85,
        reasoning: "Derived from partner onboarding documentation.",
      },
      sales_motion: {
        value: "Solution Selling",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.8,
        reasoning: "Based on vendor product classification.",
      },
      sales_motion_positive_insight: {
        value: "Solution Selling",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.85,
        reasoning: "Customer satisfaction surveys.",
      },
      sales_motion_negative_insight: {
        value: "Solution Selling",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.7,
        reasoning: "No ambulatory offerings available.",
      },
      sales_motion_recent_development: {
        value: "Solution Selling",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.8,
        reasoning: "Confirmed in feature update report.",
      },
      focus_area: {
        value: "High",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.9,
        reasoning: "Measured by deployment across all departments.",
      },
      focus_area_positive_insight: {
        value: "Fully integrated across EMR and billing.",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.85,
        reasoning: "Feedback from implementation teams.",
      },
      focus_area_negative_insight: {
        value: "Integration delays in 2 sites.",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.7,
        reasoning: "Deployment status reports.",
      },
      focus_area_recent_development: {
        value: "Resolved API issues in July.",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.75,
        reasoning: "Engineering resolution ticket logged.",
      },
    },
  ];

  useEffect(() => {
    const transformed = transformResultsToCompProfileData(
      marketingGeographicCoverage
    );
    setTabData(transformed);
    setTableBelowDescription(
      // formatBoldText(
      //   // transformed?.[0]?.competitive_commentary
      //   marketingGeographicCoverage?.[0]?.response?.tableComments
      // )
      <ParsedTextWithLinks
        text={marketingGeographicCoverage?.[0]?.response?.tableComments || ""}
      />
    );
    // console.log("MAS: " + JSON.stringify(transformed));
    // setTabData(dummyData);
  }, [marketingGeographicCoverage]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    // { type: "conversation", title: "Conversation", onClick: () => {} },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  return (
    <InsightTable
      title="Marketing Geographic Coverage"
      subtitle="Regional marketing investment allocation and competitive reach by geography."
      belowTableDescription={tableBelowDescription}
      data={tabData}
      metrics={allMetrics}
      rowIdentifier="region"
      actions={actions}
    />
  );
}

export default MarketingGeographicCoverage;
